import { useEffect, useState } from "react";
import { getTenantAcl, TenantAclResponse } from "../../apis";

/** The tenant's logo from its ACL: the main logo, else the medium size, else none (""). The job form's rule. */
export const readTenantLogo = (acl: TenantAclResponse): string => acl.companyInfo?.logo || acl.companyInfo?.logos?.medium || "";

/**
 * The signed-in user's tenant logo, read from the tenant ACL (`GET /integrations/tenant/acl`) on mount — the
 * source the job form uses. "" until it loads, and for good when the tenant has no logo or the read fails:
 * a missing logo is never an error, the layout simply renders without one.
 */
const useTenantLogo = (): string => {
  const [logo, setLogo] = useState("");

  useEffect(() => {
    let active = true;
    getTenantAcl()
      .then(acl => {
        if (active) setLogo(readTenantLogo(acl));
      })
      .catch(() => {
        // non-fatal: no logo
      });
    return () => {
      active = false;
    };
  }, []);

  return logo;
};

export default useTenantLogo;
